import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from 'src/Common/Models/UATConstants';

/**
 * Base API for all services that use the CommonServicesWebApiUrl
 * This API will serve as the base for injecting endpoints from other API slices
 */
export const commonServicesBaseApi = createApi({
  reducerPath: 'commonServicesApi',
  keepUnusedDataFor: 1800, // Keep unused data for 30 minutes (in seconds)
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.CommonServicesWebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(UATConstants.jwtTokenForApi);
      const coreAPIToken = sessionStorage.getItem(UATConstants.jwtTokenForCoreApi);
      const graphToken = sessionStorage.getItem(UATConstants.jwtTokenForGraph);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      }
      
      headers.set('Accept', 'application/json');
      headers.set('Content-Type', 'application/json');

      return headers;
    },
  }),
  tagTypes: [
    'CopilotInsights',
    'TotalRequests', 
    'CriticalAgingRequests', 
    'AppUserData',
    'Opportunity'
  ],
  endpoints: () => ({}), // Empty endpoints object - we'll inject endpoints from other files
});

// Export an empty object of hooks - will be filled by the injected endpoints
export const commonServicesHooks = {};
